document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll("[data-kilo-header]");

  headers.forEach((header) => {
    const headerGroup = document.querySelector("#header-group");
    const isTouchLikeViewport = () =>
      window.matchMedia("(hover: none), (pointer: coarse)").matches;
    const isMobileViewport = () => window.matchMedia("(max-width: 767px)").matches;
    const navItems = header.querySelectorAll("[data-kilo-nav-item]");
    const inner = header.querySelector(".kilo-header__inner");
    const mobileToggle = header.querySelector("[data-kilo-mobile-toggle]");
    const mobileDrawer = header.querySelector("[data-kilo-mobile-drawer]");
    const mobilePanels = header.querySelectorAll("[data-kilo-mobile-panel]");
    const mobileOpenButtons = header.querySelectorAll(
      "[data-kilo-mobile-open]",
    );
    const mobileBackButtons = header.querySelectorAll(
      "[data-kilo-mobile-back]",
    );

    if (!navItems.length || !inner) return;

    let baseHeight = header.offsetHeight;

    const updateHeaderHeights = () => {
      if (!(headerGroup instanceof HTMLElement)) return;

      const headerSection = header.closest(".shopify-section");
      let headerGroupHeight = 0;

      Array.from(headerGroup.children).forEach((child) => {
        if (!(child instanceof HTMLElement)) return;

        if (child === headerSection) {
          headerGroupHeight += header.offsetHeight;
          return;
        }

        headerGroupHeight += child.offsetHeight;
      });

      document.body.style.setProperty("--header-height", `${header.offsetHeight}px`);
      document.body.style.setProperty("--header-group-height", `${headerGroupHeight}px`);
    };

    const updateMobileStickyState = () => {
      header.classList.toggle(
        "is-scrolled",
        isMobileViewport() && window.scrollY > 8,
      );
    };

    const resetMobilePanels = () => {
      mobilePanels.forEach((panel) => {
        panel.classList.toggle(
          "is-active",
          panel.getAttribute("data-kilo-mobile-panel") === "root",
        );
      });
    };

    const closeMobileMenu = () => {
      header.classList.remove("is-mobile-open");
      if (mobileToggle) {
        mobileToggle.setAttribute("aria-expanded", "false");
      }
      if (mobileDrawer) {
        mobileDrawer.hidden = true;
      }
      resetMobilePanels();
      updateHeaderHeights();
    };

    const openMobilePanel = (panelId) => {
      mobilePanels.forEach((panel) => {
        panel.classList.toggle(
          "is-active",
          panel.getAttribute("data-kilo-mobile-panel") === panelId,
        );
      });
    };

    const updateBaseHeight = () => {
      header.style.height = "";
      header.classList.remove("has-open-panel");
      baseHeight = header.offsetHeight;
    };

    const setExpandedHeight = (item) => {
      const panel = item.querySelector("[data-kilo-panel]");
      if (!panel) {
        header.style.height = "";
        header.classList.remove("has-open-panel");
        return;
      }

      header.classList.add("has-open-panel");

      const innerRect = inner.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();

      const panelBottomInsideHeader = panelRect.bottom - innerRect.top;
      const neededHeight = Math.ceil(panelBottomInsideHeader + 24);

      header.style.height = `${Math.max(baseHeight, neededHeight)}px`;
    };

    const closeAll = () => {
      navItems.forEach((item) => {
        item.classList.remove("is-open");

        const trigger = item.querySelector(
          ".kilo-nav__top-link[aria-expanded]",
        );
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      });

      header.classList.remove("is-dark");
      header.classList.remove("has-open-panel");
      header.style.height = "";
      updateBaseHeight();
    };

    const openItem = (item) => {
      navItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("is-open");
          const otherTrigger = otherItem.querySelector(
            ".kilo-nav__top-link[aria-expanded]",
          );
          if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
        }
      });

      item.classList.add("is-open");

      const trigger = item.querySelector(".kilo-nav__top-link[aria-expanded]");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "true");
      }

      header.classList.add("is-dark");
      setExpandedHeight(item);
    };

    updateBaseHeight();
    updateHeaderHeights();
    updateMobileStickyState();

    resetMobilePanels();

    navItems.forEach((item) => {
      const trigger = item.querySelector(".kilo-nav__top-link[aria-expanded]");

      if (trigger) {
        trigger.addEventListener("click", (event) => {
          if (!isTouchLikeViewport()) return;
          if (item.classList.contains("is-open")) return;

          event.preventDefault();
          openItem(item);
        });
      }

      item.addEventListener("mouseenter", () => {
        openItem(item);
      });

      item.addEventListener("focusin", () => {
        openItem(item);
      });
    });

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener("click", () => {
        const shouldOpen = mobileDrawer.hidden;

        if (shouldOpen) {
          header.classList.add("is-mobile-open");
          mobileDrawer.hidden = false;
          mobileToggle.setAttribute("aria-expanded", "true");
          resetMobilePanels();
          closeAll();
          updateHeaderHeights();
        } else {
          closeMobileMenu();
        }
      });
    }

    mobileOpenButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const panelId = button.getAttribute("data-kilo-mobile-open");
        if (!panelId) return;
        openMobilePanel(panelId);
      });
    });

    mobileBackButtons.forEach((button) => {
      button.addEventListener("click", () => {
        openMobilePanel("root");
      });
    });

    document.addEventListener("click", (event) => {
      if (!(event.target instanceof Node)) return;
      if (!header.contains(event.target)) {
        closeAll();
        closeMobileMenu();
      }
    });

    header.addEventListener("mouseleave", closeAll);

    header.addEventListener("focusout", function () {
      requestAnimationFrame(() => {
        if (!header.contains(document.activeElement)) {
          closeAll();
        }
      });
    });

    window.addEventListener("resize", () => {
      const openItemEl = header.querySelector(".kilo-nav__item.is-open");
      updateBaseHeight();
      updateHeaderHeights();
      updateMobileStickyState();

      if (openItemEl) {
        setExpandedHeight(openItemEl);
      }

      if (window.innerWidth > 767) {
        closeMobileMenu();
      }
    });

    window.addEventListener("scroll", updateMobileStickyState, { passive: true });
  });
});
